/* eslint-disable react/prop-types */
import React from "react";
import { STEPS, STEP_LABELS, STEP_ORDER } from "../constants";

/**
 * A ledger, not a wizard.
 *
 * Each step keeps its resolved value on screen for the rest of the flow. The
 * patient's name in particular has to stay visible — a quotation raised against
 * the wrong account is the costly error in this job, and it's silent.
 */
const StepLedger = ({ current, values, onStepBack }) => {
    const currentIndex = STEP_ORDER.indexOf(current);

    return (
        <ol className="flex flex-wrap items-stretch gap-x-8 gap-y-3">
            {STEP_ORDER.map((step, index) => {
                const isDone = index < currentIndex;
                const isCurrent = step === current;
                const value = values[step];
                const canGoBack = isDone && step !== STEPS.QUOTE && current !== STEPS.QUOTE;

                return (
                    <li key={step} className="flex min-w-[7.5rem] flex-col">
                        <span className="flex items-center gap-1.5">
                            <span
                                className={`text-[10px] font-semibold tabular-nums ${isCurrent ? "text-elm-600" : "text-cod-gray-300"
                                    }`}
                            >
                                {String(index + 1).padStart(2, "0")}
                            </span>
                            <span
                                className={`text-[11px] font-semibold uppercase tracking-[0.1em] ${isCurrent ? "text-cod-gray-900" : "text-cod-gray-400"
                                    }`}
                            >
                                {STEP_LABELS[step]}
                            </span>
                        </span>

                        <span className="mt-1.5 block h-px w-full bg-cod-gray-100">
                            <span
                                className={`block h-px transition-all duration-300 motion-reduce:transition-none ${isDone || isCurrent ? "w-full bg-elm-500" : "w-0"
                                    }`}
                            />
                        </span>

                        <span className="mt-2 min-h-[1.25rem] text-[13px] leading-tight text-cod-gray-500">
                            {canGoBack ? (
                                <button
                                    type="button"
                                    onClick={() => onStepBack(step)}
                                    className="text-left text-cod-gray-900 underline decoration-cod-gray-200 underline-offset-4 hover:decoration-elm-500"
                                >
                                    {value}
                                </button>
                            ) : (
                                value || <span className="text-cod-gray-200">—</span>
                            )}
                        </span>
                    </li>
                );
            })}
        </ol>
    );
};

export default StepLedger;
